import { render, staticRenderFns } from "./VErrorResponce.vue?vue&type=template&id=65a6c19c"
import script from "./VErrorResponce.vue?vue&type=script&lang=js"
export * from "./VErrorResponce.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports